<div class="weergave" [class]="param()">
	<app-single-select-dropdown
		[label]="label()"
		[opties]="opties()"
		[selectedOptie]="optie()"
		(onOptieClicked)="qp.dispatch(param(), $event)"
	></app-single-select-dropdown>
</div>
